import api, { api_v2 } from "@/api/axios.config"

export interface RepriseItem {
  id: number | string
  descricao?: string
  produto_descricao?: string | null
  data_inicio: string | null
  data_fim: string | null
  data_limite_inscricao: string | null
  local: string | null
  form_id: number | null
  mostra_lp: string | null
  link_drive: string | null
  link_capa: string | null
  limite_exibicao: string | null
}

interface ReprisesResponse {
  total: number
  data: RepriseItem[]
}

export interface Evento {
  id: number
  descricao: string
  dataInicio: string // ISO 8601
  dataFim: string // ISO 8601
  dataLimiteInscricao: string // ISO 8601
  local: string | null
  formId: number
  mostraLp: "S" | "N"
  linkConteudo: string | null
  produtoDescricao: string
  linkCapa: string | null
  limiteExibicao: number | null
  agrupador: string | null
}

export interface PaginationMeta {
  total: number
  page: number
  limit: number
  hasMore?: boolean
}

export interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
  meta: PaginationMeta
}

// Exemplo de uso para a lista de eventos:
export type EventosResponse = ApiResponse<Evento[]>

export const getReprisesAction = async (params?: {
  page?: number
  limit?: number
  search?: string
  status?: string
  agrupador?: string
}) => {
  return api_v2.get<EventosResponse>("/plataforma/conteudos", { params })
}

export function extractDriveFileId(url: string): string | null {
  if (!url) return null
  const patterns = [/\/file\/d\/([a-zA-Z0-9_-]+)/, /id=([a-zA-Z0-9_-]+)/, /\/d\/([a-zA-Z0-9_-]+)/]
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }
  return null
}

export function buildDriveEmbedUrl(driveUrl: string): string | null {
  const fileId = extractDriveFileId(driveUrl)
  if (!fileId) return null
  return `https://drive.google.com/file/d/${fileId}/preview?rm=minimal`
}

export function extractYoutubeVideoId(url: string): string | null {
  if (!url) return null
  const patterns = [
    /youtu\.be\/([a-zA-Z0-9_-]+)/,
    /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/,
    /youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/,
  ]
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }
  return null
}

export function getYoutubeThumbnail(youtubeUrl: string): string | null {
  const videoId = extractYoutubeVideoId(youtubeUrl)
  if (!videoId) return null
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
}

export function updateContent(payload: {
  idConteudo: string | number
  idEvento: number
  linkConteudo: string
  linkSegundoConteudo?: string | null
  linkCapa: string
  limiteExibicao: string
}): Promise<void> {
  return api_v2.put(`/plataforma/conteudos`, payload)
}

export function createContent(payload: {
  idEvento: number
  linkConteudo: string
  linkSegundoConteudo?: string | null
  linkCapa: string
  limiteExibicao: string
}): Promise<void> {
  return api_v2.post(`/plataforma/conteudos`, payload)
}

export function deleteContent(idConteudo: string | number): Promise<void> {
  return api_v2.delete(`/plataforma/conteudos/${idConteudo}`)
}

export function getImersoes(params?: { page?: number; limit?: number; search?: string }) {
  return api_v2.get("/plataforma/listar-eventos", { params })
}
